import { getDataSession, LOCAL_STORAGE } from "helper/session";
import _ from "lodash";
import { KEY_ROLE_BIZZ_UAA, ROLE, UAA_CHILDREN_PATH } from "./constant";

export const menus = [
  {
    name: "menu.uaa.dashboard",
    path: UAA_CHILDREN_PATH.ULTILITIES_DASHBOARD,
    roles: [
      // ROLE.ADMIN,
      ROLE.HO_STAFF,
      ROLE.HO_BO,
      ROLE.HO_REVIEWER,
      ROLE.MD_EXTERNAL_BO,
      ROLE.MD_EXTERNAL_REVIEWER,
      ROLE.MD_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_BO,
      ROLE.SA_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_REVIEWER,
      ROLE.AGENT_KEY_EXTERNAL,
    ],
  },
  {
    name: "menu.uaa.channel_management",
    type: "collapse",
    roles: [
      ROLE.ADMIN,
      ROLE.HO_STAFF,
      ROLE.HO_BO,
      ROLE.HO_REVIEWER,
      ROLE.SA_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_BO,
      ROLE.SA_EXTERNAL_REVIEWER,
      ROLE.MD_EXTERNAL_BO,
      ROLE.MD_EXTERNAL_STAFF,
      ROLE.MD_EXTERNAL_REVIEWER,
    ],
    children: [
      {
        name: "menu.uaa.overview",
        path: UAA_CHILDREN_PATH.OVERVIEW,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_STAFF,
          ROLE.HO_BO,
          ROLE.HO_REVIEWER,
          ROLE.SA_EXTERNAL_STAFF,
          ROLE.SA_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.MD_EXTERNAL_BO,
          ROLE.MD_EXTERNAL_STAFF,
          ROLE.MD_EXTERNAL_REVIEWER,
        ],
      },

      {
        name: "menu.uaa.register_create_request",
        path: UAA_CHILDREN_PATH.REGISTER_CREATE_REQUEST,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_BO,
          ROLE.HO_STAFF,
          ROLE.HO_REVIEWER,
          ROLE.SA_EXTERNAL_STAFF,
        ],
      },
      {
        name: "menu.uaa.register_approve_request",
        path: UAA_CHILDREN_PATH.REGISTER_APPROVE_REQUEST,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_BO,
          ROLE.HO_REVIEWER,
          // ROLE.SA_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.HO_STAFF,
        ],
      },
      {
        name: "menu.uaa.update_approve_request",
        path: UAA_CHILDREN_PATH.UPDATE_APPROVE_REQUEST,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_BO,
          ROLE.HO_REVIEWER,
          ROLE.SA_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_REVIEWER,
        ],
      },
      {
        name: "menu.uaa.cancel_create_request",
        path: UAA_CHILDREN_PATH.CANCEL_CREATE_REQUEST,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_BO,
          ROLE.HO_STAFF,
          ROLE.HO_REVIEWER,
          ROLE.SA_EXTERNAL_STAFF,
        ],
      },
      {
        name: "menu.uaa.cancel_approve_request",
        path: UAA_CHILDREN_PATH.CANCEL_APPROVE_REQUEST,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_BO,
          ROLE.HO_REVIEWER,
          ROLE.SA_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_REVIEWER,
        ],
      },
    ],
  },

  {
    name: "menu.uaa.funding_management",
    type: "collapse",
    roles: [
      ROLE.ADMIN,
      ROLE.SA_EXTERNAL_BO,
      ROLE.SA_EXTERNAL_REVIEWER,
      ROLE.SA_EXTERNAL_STAFF,
      ROLE.MD_EXTERNAL_BO,
      ROLE.MD_EXTERNAL_REVIEWER,
      ROLE.MD_EXTERNAL_STAFF,
      ROLE.AGENT_KEY_EXTERNAL,
      ROLE.HO_STAFF,
      ROLE.HO_BO,
      ROLE.HO_REVIEWER,
    ],
    children: [
      {
        name: "menu.uaa.create-funding",
        path: UAA_CHILDREN_PATH.FUNDING_REQUEST,
        roles: [
          ROLE.ADMIN,
          ROLE.SA_EXTERNAL_BO,
          ROLE.MD_EXTERNAL_BO,
          ROLE.AGENT_KEY_EXTERNAL,
        ],
      },
      {
        name: "menu.uaa.review-funding",
        path: UAA_CHILDREN_PATH.FUNDING_REVIEW,
        roles: [
          ROLE.ADMIN,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.MD_EXTERNAL_REVIEWER,
          ROLE.HO_REVIEWER,
        ],
      },
      {
        name: "menu.uaa.approve-funding",
        path: UAA_CHILDREN_PATH.FUNDING_APPROVE,
        roles: [
          ROLE.ADMIN,
          ROLE.SA_EXTERNAL_BO,
          ROLE.MD_EXTERNAL_BO,
          ROLE.HO_BO,
        ],
      },
      {
        name: "menu.uaa.create-withdraw",
        path: UAA_CHILDREN_PATH.WITHDRAW_CREATE,
        roles: [
          ROLE.ADMIN,
          ROLE.SA_EXTERNAL_BO,
          ROLE.MD_EXTERNAL_BO,
          ROLE.AGENT_KEY_EXTERNAL,
        ],
      },
      {
        name: "menu.uaa.review-withdraw",
        path: UAA_CHILDREN_PATH.WITHDRAW_REQUEST,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_REVIEWER,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.MD_EXTERNAL_REVIEWER,
        ],
      },
      {
        name: "menu.uaa.approve-withdraw",
        path: UAA_CHILDREN_PATH.WITHDRAW_APPROVE,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_BO,
          ROLE.SA_EXTERNAL_BO,
          ROLE.MD_EXTERNAL_BO,
        ],
      },
      {
        name: "menu.uaa.cash-in-request",
        path: UAA_CHILDREN_PATH.CASH_IN_REQUEST,
        roles: [
          ROLE.MD_EXTERNAL_BO,
          // ROLE.MD_EXTERNAL_REVIEWER,
          ROLE.MD_EXTERNAL_STAFF,
          ROLE.SA_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_STAFF,
          ROLE.HO_BO,
          ROLE.HO_STAFF,
          ROLE.ADMIN,
        ],
      },
      {
        name: "menu.uaa.cash-in-approve",
        path: UAA_CHILDREN_PATH.CASH_IN_APPROVE,
        roles: [
          ROLE.ADMIN,
          ROLE.MD_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_BO,
          ROLE.HO_BO,
        ],
      },
    ],
  },
  {
    name: "menu.uaa.payment_management",
    type: "collapse",
    roles: [
      ROLE.SA_EXTERNAL_STAFF,
      ROLE.MD_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_BO,
      ROLE.MD_EXTERNAL_BO,
    ],
    children: [
      {
        name: "menu.uaa.batch_management_create_request",
        path: UAA_CHILDREN_PATH.PAYMENT_BATCH_REQUEST,
        roles: [ROLE.SA_EXTERNAL_STAFF, ROLE.MD_EXTERNAL_STAFF],
      },
      {
        name: "menu.uaa.batch_management_approve_request",
        path: UAA_CHILDREN_PATH.PAYMENT_BATCH_APPROVE,
        roles: [ROLE.SA_EXTERNAL_BO, ROLE.MD_EXTERNAL_BO],
      },
    ],
  },

  {
    name: "menu.uaa.manage_sys_user",
    type: "item",
    path: UAA_CHILDREN_PATH.MANAGE_SYS_USER_LIST,
    roles: [
      ROLE.ADMIN,
      ROLE.HO_STAFF,
      ROLE.HO_BO,
      ROLE.HO_REVIEWER,
      ROLE.MD_EXTERNAL_BO,
      ROLE.MD_EXTERNAL_REVIEWER,
      ROLE.MD_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_BO,
      ROLE.SA_EXTERNAL_REVIEWER,
      ROLE.SA_EXTERNAL_STAFF,
    ],
  },
  {
    name: "menu.uaa.utilities",
    type: "collapse",
    roles: [
      ROLE.ADMIN,
      ROLE.HO_STAFF,
      ROLE.HO_BO,
      ROLE.HO_REVIEWER,
      ROLE.MD_EXTERNAL_BO,
      ROLE.MD_EXTERNAL_REVIEWER,
      ROLE.MD_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_BO,
      ROLE.SA_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_REVIEWER,
      ROLE.AGENT_EXTERNAL,
      ROLE.AGENT_IN_SHOP_EXTERNAL,
      ROLE.AGENT_KEY_EXTERNAL,
    ],
    children: [
      {
        name: "menu.uaa.trans-history",
        path: UAA_CHILDREN_PATH.ULTILITIES_TRANSACTION,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_STAFF,
          ROLE.HO_BO,
          ROLE.HO_REVIEWER,
          ROLE.MD_EXTERNAL_BO,
          ROLE.MD_EXTERNAL_REVIEWER,
          ROLE.MD_EXTERNAL_STAFF,
          ROLE.SA_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_STAFF,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.AGENT_KEY_EXTERNAL,
        ],
      },
    ],
  },
  {
    name: "menu.uaa.report",
    type: "collapse",
    roles: [
      ROLE.ADMIN,
      ROLE.HO_STAFF,
      ROLE.HO_BO,
      ROLE.HO_REVIEWER,
      ROLE.MD_EXTERNAL_BO,
      ROLE.MD_EXTERNAL_REVIEWER,
      ROLE.MD_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_BO,
      ROLE.SA_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_REVIEWER,
      ROLE.AGENT_EXTERNAL,
      ROLE.AGENT_IN_SHOP_EXTERNAL,
      ROLE.AGENT_KEY_EXTERNAL,
    ],
    children: [
      {
        name: "menu.uaa.report_channel",
        path: UAA_CHILDREN_PATH.REPORT_CHANNELS,
        roles: [
          ROLE.ADMIN,
          ROLE.HO_STAFF,
          ROLE.HO_BO,
          ROLE.HO_REVIEWER,
          ROLE.SA_EXTERNAL_BO,
        ],
      },
      {
        name: "menu.uaa.report_total_trans",
        path: UAA_CHILDREN_PATH.REPORT_TOTAL_TRANS,
        roles: [
          ROLE.ADMIN,
          ROLE.MD_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_BO,
          ROLE.AGENT_KEY_EXTERNAL,
        ],
      },

      {
        name: "menu.uaa.commission_staff_report",
        path: UAA_CHILDREN_PATH.COMMISSION_STAFF_REPORT,
        roles: [ROLE.ADMIN, ROLE.MD_EXTERNAL_BO],
      },
      {
        name: "menu.uaa.report_trans_detail_bydate",
        path: UAA_CHILDREN_PATH.REPORT_TRANSACTION_DETAIL_BYDATE,
        roles: [
          ROLE.ADMIN,
          ROLE.MD_EXTERNAL_BO,
          ROLE.SA_EXTERNAL_BO,
          ROLE.AGENT_KEY_EXTERNAL,
        ],
      },
      {
        name: "menu.uaa.report_commission",
        path: UAA_CHILDREN_PATH.REPORT_COMMISSION_LIST,
        roles: [ROLE.MD_EXTERNAL_BO, ROLE.SA_EXTERNAL_BO],
      },
      {
        name: "menu.uaa.report_commission_percentage",
        path: UAA_CHILDREN_PATH.REPORT_PERCENTAGES,
        roles: [ROLE.MD_EXTERNAL_BO, ROLE.SA_EXTERNAL_BO],
      },
    ],
  },
];
const roleCurrentStore = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);

export const getMenuItemsByRoles = (output, menus, roleCurrent) => {
  const { code: key } = Object(roleCurrent) || {};
  if (!menus || menus.length <= 0) return _.omit({ ...output }, ["children"]);

  // const configReview = getDataSession(LOCAL_STORAGE, CONFIG_REVIEW);

  const menuFilter =
    menus
      ?.filter(
        (item) => _.isEmpty(item.roles) || item.roles.includes(key)
        //  && (item.showMenu === configReview || !item.showMenu)
      )
      .map((itemMenu) => {
        return getMenuItemsByRoles(
          { ...itemMenu, children: [] },
          itemMenu.children,
          roleCurrent
        );
      }) || [];

  return { ...output, children: menuFilter };
};

export const navigateConfigChannelMenu = {
  bizzApp: "CHANNEL",
  children: [
    {
      name: "menu.uaa.dashboard",
      path: UAA_CHILDREN_PATH.ULTILITIES_DASHBOARD,
      type: "item"
    },
    {
      name: "menu.uaa.overview",
      path: UAA_CHILDREN_PATH.OVERVIEW,
      type: "item"
    },
    {
      name: "menu.uaa.register_create_request",
      path: UAA_CHILDREN_PATH.REGISTER_CREATE_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.register_approve_request",
      path: UAA_CHILDREN_PATH.REGISTER_APPROVE_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.update_approve_request",
      path: UAA_CHILDREN_PATH.UPDATE_APPROVE_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.cancel_create_request",
      path: UAA_CHILDREN_PATH.CANCEL_CREATE_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.cancel_approve_request",
      path: UAA_CHILDREN_PATH.CANCEL_APPROVE_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.create-funding",
      path: UAA_CHILDREN_PATH.FUNDING_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.review-funding",
      path: UAA_CHILDREN_PATH.FUNDING_REVIEW,
      type: "item"
    },
    {
      name: "menu.uaa.approve-funding",
      path: UAA_CHILDREN_PATH.FUNDING_APPROVE,
      type: "item"
    },
    {
      name: "menu.uaa.create-withdraw",
      path: UAA_CHILDREN_PATH.WITHDRAW_CREATE,
      type: "item"
    },
    {
      name: "menu.uaa.review-withdraw",
      path: UAA_CHILDREN_PATH.WITHDRAW_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.approve-withdraw",
      path: UAA_CHILDREN_PATH.WITHDRAW_APPROVE,

    },
    {
      name: "menu.uaa.cash-in-request",
      path: UAA_CHILDREN_PATH.CASH_IN_REQUEST,
      type: "item"
    },
    {
      name: "menu.uaa.cash-in-approve",
      path: UAA_CHILDREN_PATH.CASH_IN_APPROVE,
      type: "item"
    },
    {
      name: "menu.uaa.batch_management_create_request",
      path: UAA_CHILDREN_PATH.PAYMENT_BATCH_REQUEST,
      type: "item",
    },
    {
      name: "menu.uaa.batch_management_approve_request",
      path: UAA_CHILDREN_PATH.PAYMENT_BATCH_APPROVE,
      type: "item",
    },
    {
      name: "menu.uaa.manage_sys_user",
      path: UAA_CHILDREN_PATH.MANAGE_SYS_USER_LIST,
      type: "item",
    },
    {
      name: "menu.uaa.trans-history",
      path: UAA_CHILDREN_PATH.ULTILITIES_TRANSACTION,
      type: "item",
    },
    {
      name: "menu.uaa.report_channel",
      path: UAA_CHILDREN_PATH.REPORT_CHANNELS,
      type: "item",
    },
    {
      name: "menu.uaa.report_total_trans",
      path: UAA_CHILDREN_PATH.REPORT_TOTAL_TRANS,
      type: "item",
    },

    {
      name: "menu.uaa.commission_staff_report",
      path: UAA_CHILDREN_PATH.COMMISSION_STAFF_REPORT,
      roles: [ROLE.ADMIN, ROLE.MD_EXTERNAL_BO],
      type: "item",
    },
    {
      name: "menu.uaa.report_trans_detail_bydate",
      path: UAA_CHILDREN_PATH.REPORT_TRANSACTION_DETAIL_BYDATE,
      type: "item",
    },
    {
      name: "menu.uaa.report_commission",
      path: UAA_CHILDREN_PATH.REPORT_COMMISSION_LIST,
      type: "item",
    },
    {
      name: "menu.uaa.report_commission_percentage",
      path: UAA_CHILDREN_PATH.REPORT_PERCENTAGES,
      type: "item",
    },
  ]
};
